import { cast } from 'redpoints-front-common/helpers';

import {
  DOMAINS_PLATFORMS_TREE_CHILDREN_KEY,
  DOMAINS_PLATFORMS_TREE_PARENT_KEY,
  filtersCastOptions,
} from '../../../config/testPurchaseConfiguration';
import FilterByEnum from '../../../enumerations/FilterBy';

const reduceTreeValuesToSelected = (extractedValues, value) => {
  const [type, id] = value.split('_');
  if (extractedValues?.[type]) {
    extractedValues[type].push(cast.number(id));
  }
  return extractedValues;
};

export const parseTreeValuesToSelected = values =>
  values.reduce(reduceTreeValuesToSelected, {
    [DOMAINS_PLATFORMS_TREE_PARENT_KEY]: [],
    [DOMAINS_PLATFORMS_TREE_CHILDREN_KEY]: [],
  });

export const getTestPurchaseValidQueryParamsHelper = ({
  availableDomainIds,
  availableDomainPlatformIds,
  queryParams,
}) => {
  let validQueryParams = {};

  const castedQueryParams = cast(filtersCastOptions)(queryParams);

  const domainId = (castedQueryParams.domainId ?? []).filter(id =>
    availableDomainIds.includes(id)
  );

  if (domainId.length) {
    validQueryParams = { ...validQueryParams, domainId };
  }

  const domainPlatformId = (
    castedQueryParams.domainPlatformId ?? []
  ).filter(id => availableDomainPlatformIds.includes(id));

  if (domainPlatformId.length) {
    validQueryParams = { ...validQueryParams, domainPlatformId };
  }

  const filterBy = castedQueryParams.filterBy?.name ?? null;
  if (filterBy != null) {
    validQueryParams = { ...validQueryParams, filterBy };
  }
  return validQueryParams;
};

export const getContextDataFromFilterBy = (filterBy, context) => {
  switch (filterBy) {
    case FilterByEnum.CONTRACT.name:
      return {
        customerId: context?.customerId,
        contractId: context?.contractId,
      };
    case FilterByEnum.CUSTOMER.name:
      return {
        customerId: context?.customerId,
      };
    default:
      return {};
  }
};
